<template>
  <div>
    <header class="header">
      <h1>
        <a :href="home"><img :src="require('@/assets/img/logo.png')" alt="" /></a>
      </h1>
      <div class="search-wrap">
        <i @click="searchEvent"><svg t="1589350342740" viewBox="0 0 1024 1024" version="1.1"
            xmlns="http://www.w3.org/2000/svg" p-id="2244" width="20" height="20">
            <path
              d="M402.6 56c48.2 0 94.8 9.4 138.8 28 42.5 18 80.6 43.7 113.4 76.4 32.8 32.8 58.5 70.9 76.4 113.4 18.6 43.9 28 90.6 28 138.8s-9.4 94.8-28 138.8c-18 42.5-43.7 80.6-76.4 113.4-32.8 32.8-70.9 58.5-113.4 76.4-43.9 18.6-90.6 28-138.8 28s-94.8-9.4-138.8-28c-42.5-18-80.6-43.7-113.4-76.4C117.7 632 92 593.8 74 551.4c-18.6-43.9-28-90.6-28-138.8s9.4-94.8 28-138.8c18-42.5 43.7-80.6 76.4-113.4 32.8-32.8 70.9-58.5 113.4-76.4 43.9-18.6 90.6-28 138.8-28m0-40C183.6 16 6 193.6 6 412.6s177.6 396.6 396.6 396.6 396.6-177.6 396.6-396.6S621.6 16 402.6 16zM687.4 658.9c-4.5 0-8.9 1.7-12.3 5.1l-3.6 3.6c-6.8 6.8-6.8 17.9 0 24.7l312.9 312.9c3.4 3.4 7.9 5.1 12.3 5.1s8.9-1.7 12.3-5.1l3.6-3.6c6.8-6.8 6.8-17.9 0-24.7L699.7 664c-3.4-3.4-7.9-5.1-12.3-5.1z"
              fill="#dcdfe6" p-id="2245"></path>
          </svg></i>
        <input type="search" v-model="meta.keyword" @keydown.enter="searchEvent" />
      </div>
    </header>
    <div :class="{ 'info-wrap': voteIntroShow }">
      <section v-if="voteIntroShow" class="vote-info-bar">
        <h2>投票说明：</h2>
        <div class="vote-info-content">
          <p><span>①</span>每人每天只有5票，可多次登录投票</p>
          <p><span>②</span>每人每天不得给单幅 参赛作品重复投票</p>
          <p><span>③</span>如发现恶意刷票，取消作者参赛资格</p>
        </div>
        <div class='schedule'>人气投票：11月1日-11月30日 </div>
      </section>
      <!-- <step-tab /> -->
      <div class="tools-bar" v-if="$route.name === 'WorksList'">
        <div v-if="voteIntroShow" class="sort">
          <div class="sort-item" :class="{ active: sortActive === 0 }" @click="sortActiveEvent(0)">
            时间
          </div>
          <div class="sort-item" :class="{ active: sortActive === 1 }" @click="sortActiveEvent(1)">
            票数
          </div>
          <!-- <div
            class="sort-item"
            :class="{ active: sortActive === 2 }"
            @click="sortActiveEvent(2)"
          >
            随机
          </div> -->
        </div>
        <div v-if="!voteIntroShow" class="sort">
          <div class="sort-item" :class="{ active: sortActive === 0 }" @click="sortActiveEvent(0)">
            时间
          </div>
          <!-- <div
            class="sort-item"
            :class="{ active: sortActive === 2 }"
            @click="sortActiveEvent(2)"
          >
            随机
          </div> -->
        </div>
        <div v-if="$route.name === 'WorksList' && voteIntroShow" class="right-wrap">
          <div class="selected">
            <el-badge :value="selectedArr.length" class="item">
              <svg class="icon" aria-hidden="true">
                <use xlink:href="#icon-selected"></use>
              </svg>
            </el-badge>
            <span>已选</span>
          </div>
          <BaseButton class="vote-btn" @click="voteEvent" :disable='disable'>投票</BaseButton>
        </div>
      </div>
      <div class="tab-nav" v-if="$route.name === 'WorksList'">
        <van-tabs v-model="tabIndex" @change="typeChange">
          <van-tab title="相机赛区"></van-tab>
          <van-tab title="手机赛区"></van-tab>
        </van-tabs>
      </div>


    </div>

    <router-view ref="route"></router-view>
  </div>
</template>
<script>
import { mapState, mapGetters, mapMutations } from "vuex";
import worksApi from "@/api/works";
import StepTab from './StepTab.vue';
import Summer from '../common/Summer.vue';

export default {
  components: { StepTab, Summer },
  name: "WorksWrapMainMobile",
  data() {
    return {
      home: process.env.VUE_APP_HOME,
      meta: {
        keyword: "",
        currentPage: 1
      },
      tabIndex: 0,
      voteIntroShow: true,
      disable: new Date().getTime() < new Date('2022.11.01').getTime()
    };
  },
  computed: {
    ...mapState(["sortActive", "selectedArr", "imgListNum", "searchWorksType", "radioText"]),
  },
  methods: {
    ...mapMutations(["setSortActive", "setSearchWorksType"]),
    /**
     * 搜索事件
     */
    searchEvent() {
      let that = this;
      this.meta.currentPage = 1;
      this.$router.push({ path: `/works/${that.$route.params.type}`, query: this.meta });
    },
    /**
     * 设置排序方法
     */
    sortActiveEvent(val) {
      if (this.sortActive != val) {
        this.setSortActive(val);
        this.$refs.route.$children[0].fetchData(true);
      }
    },
    /**
     * 投票
     */
    async voteEvent() {
      if (this.selectedArr.length === 0) {
        this.$toast("您还没有选择作品");
        return;
      }
      let token = localStorage.getItem("token");
      if (token) {
        let { code, msg } = await worksApi.voteWorks(this.selectedArr, token);
        if (code === 200) {
          this.$toast("投票成功");

          this.$refs.route.$children[0].clearSelectedFn();
        } else if (code === 201) {
          this.$toast(msg);

          this.$refs.route.$children[0].clearSelectedFn();
        } else if (code === 4018) {
          localStorage.removeItem("token");
        }
      } else {
        location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx324c85c2649253d5&redirect_uri=https%3A%2F%2Fauth.benq.com.cn%2FweChat%2FgetCode&response_type=code&scope=snsapi_userinfo&state=${encodeURIComponent(
          location.origin + "/syhqds2022/wxAuth?redirect=" + location.pathname + "&"
        )}#wechat_redirect`;
      }
    },
    typeChange(name, title) {
      this.setSearchWorksType(name);
      this.$refs.route.$children[0].fetchData(true);
    },
  },

  created() {
    this.tabIndex = this.searchWorksType;
    this.meta = {
      keyword: this.$route.query.keyword || "",
      currentPage: this.$route.query.currentPage || 1
    };
  }
};
</script>
<style lang="scss" scoped>
.header {
  height: 50px;
  background: $color-bg-black;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 0.4rem;

  >h1 {
    height: 100%;
    display: flex;
    align-items: center;

    img {
      display: block;
      width: 60px;
    }
  }

  .search-wrap {
    height: 30px;
    position: relative;

    >input {
      padding: 0 10px 0 40px;
      width: 6.96rem;
      height: 30px;
      border-radius: 15px;
      border: solid 1px $color-border-base;
      font-size: 14px;
      box-sizing: border-box;
      color: $color-text-regular;

      &::-webkit-search-cancel-button {
        display: none;
      }
    }

    >i {
      display: inline-block;
      position: absolute;
      top: 5px;
      left: 14px;
    }
  }
}

.info-wrap {
  padding: 0.6rem 0.4rem 0.787rem;
}

.vote-info-bar {
  color: $color-text-primary;

  h2 {
    font-size: 0.4rem;
    line-height: 0.6rem;
    font-weight: bold;
  }

  .vote-info-content {
    margin-top: 4px;
    display: flex;
    flex-wrap: wrap;
    font-size: 12px;

    >p {
      margin-top: 10px;

      >span {
        margin-right: 3px;
      }
    }
  }

  .schedule {
    margin: 20px 0;
    font-size: 14px;
  }
}

.tab-nav {
  ::v-deep [class*="van-hairline"]::after {
    border: none;
  }

  ::v-deep .van-tabs__line {
    background-color: $color-primary;
  }

  ::v-deep .van-tab--active {
    color: $color-primary;
  }

  ::v-deep .van-tab {
    color: $color-text-primary;
    font-size: 16px;
  }

  margin-top: 20px;
}

.tools-bar {
  margin-top: 0.827rem;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .sort {
    display: flex;

    .sort-item {
      text-align: center;
      line-height: 0.667rem;
      color: #bbbec4;
      font-size: 0.24rem;
      width: 1.2rem;
      height: 0.667rem;
      background: $color-border-base;

      &.active {
        background: $color-primary;
        color: $color-text-reverse;
        box-shadow: -0.027rem 0rem 0.067rem 0rem rgba(4, 0, 0, 0.2);
      }
    }
  }

  .right-wrap {
    display: flex;
  }

  .selected {
    font-size: 14px;
    display: flex;
    align-items: center;
    color: $color-primary;
    margin-right: 0.333rem;

    .icon {
      width: 18px;
      height: 24px;
      // width: 0.4rem;
      // height: 0.6rem;
      vertical-align: -0.9em;
    }

    span {
      margin-left: 8px;
    }

    ::v-deep .el-badge__content.is-fixed {
      top: 2px;
      right: 12px;
    }

    ::v-deep .el-badge__content {
      background-color: #d4003b;
    }
  }

  .vote-btn {
    width: 3.067rem;
    height: 1.067rem;
    padding: 0;
  }
}
</style>